<template>
  <div class="container">
    <div class="nav_content">
      <div class="nav_box">
        <div class="img_box">
          <img src=".../../../static/images/daishenhe.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.daiShenHe }}</div>
          <div class="state">待审核</div>
        </div>
      </div>

      <div class="nav_box">
        <div class="img_box">
          <img src=".../../../static/images/daizhipai.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.daiZhiPai }}</div>
          <div class="state">待指派</div>
        </div>
      </div>

      <div class="nav_box">
        <div class="img_box">
          <img src=".../../../static/images/paigeiwo.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.paiGeiWo }}</div>
          <div class="state">派给我</div>
        </div>
      </div>
      <div class="nav_box">
        <div class="img_box">
          <img src=".../../../static/images/wofanhuan.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.woFanHuan }}</div>
          <div class="state">我返还</div>
        </div>
      </div>
      <div class="nav_box">
        <div class="img_box">
          <img src=".../../../static/images/weixiuzhong.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.weiXiuZhong }}</div>
          <div class="state">维修中</div>
        </div>
      </div>

      <div class="nav_box">
        <div class="img_box">
          <img src=".../../../static/images/daiqueren.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.daiQueRen }}</div>
          <div class="state">待确认</div>
        </div>
      </div>
      <div class="nav_box">
        <div class="img_box">
          <img src=".../../../static/images/yiwancheng.png" alt="" />
        </div>
        <div class="num_state">
          <div class="num">{{ OrderNumData.yiWanChen }}</div>
          <div class="state">已完成</div>
        </div>
      </div>
    </div>

    <div class="search_box">
      <el-form ref="form" class="search_form" :model="tableParams" label-position="left">
        <el-form-item label="搜索内容" label-width="70px">
          <el-input v-model="tableParams.searchParam" placeholder="工单编号/联系人/电话/公司名称/车牌号" clearable  title="工单编号/联系人/电话/公司名称/车牌号"></el-input>
        </el-form-item>

        <el-form-item label="工单状态" label-width="70px">
          <el-select v-model="tableParams.orderStatus" placeholder="请选择工单状态" clearable>
            <el-option v-for="item in orderTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工单类型" label-width="70px">
          <el-select v-model="tableParams.orderType" placeholder="请选择工单类型" clearable>
            <el-option v-for="item in orderStateList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请日期" label-width="70px">
          <el-date-picker v-model="timeList" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" @change="timeChange">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button icon="el-icon-search" class="search_area_btn" @click="onSubmit">搜索</el-button>
          <el-button icon="el-icon-plus" class="search_area_btn" @click="addData">新增</el-button>
          <el-button type="text">下载模板</el-button>
          <el-button icon="el-icon-download" class="search_area_btn">导入</el-button>
          <el-button icon="el-icon-upload2" class="search_area_btn" @click="downloadExport">导出</el-button>
        </el-form-item>
        <!-- <el-form-item style="width: 100%;display: flex;justify-content: flex-end;">
          <el-button type="text">下载模板</el-button>
          <el-button icon="el-icon-download" class="search_area_btn">导入</el-button>
        </el-form-item> -->
      </el-form>
    </div>

    <div class="table_box">
      <el-table ref="singleTable" :data="tableData" highlight-current-row style="width: 100%" stripe
        v-loading="tableLoading">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column property="id" label="工单编号"> </el-table-column>
        <el-table-column property="orgName" label="企业名称"> </el-table-column>
        <el-table-column property="carNumber" label="车牌号码" width="100">
        </el-table-column>
        <el-table-column property="contactsName" label="联系人">
        </el-table-column>
        <el-table-column property="contactsPhone" label="联系方式" width="120">
        </el-table-column>
        <el-table-column property="contactsEmail" label="联系邮箱" width="120">
        </el-table-column>
        <el-table-column property="addr" label="区域地址" width="120">
        </el-table-column>
        <el-table-column property="addrDetail" label="详细地址" width="200">
        </el-table-column>
        <el-table-column property="auditUser" label="审核人">
        </el-table-column>
        <el-table-column property="workUser" label="运维人">
        </el-table-column>
        <el-table-column property="orderTypeDesc" label="工单类型" width="120">
        </el-table-column>
        <el-table-column property="orderStatusDesc" label="工单状态" width="180">
        </el-table-column>
        <el-table-column property="netAttr" label="业务属性"> </el-table-column>
        <el-table-column label="通道数量" width="100">
          <template slot-scope="scope">
            <span>{{
              scope.row.orderType === 2
              ? scope.row.netCameraNum
              : scope.row.carCameraNum
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="设备品牌">
          <template slot-scope="scope">
            <span>{{
              scope.row.orderType === 2
              ? scope.row.netCameraBrand
              : scope.row.carCameraBrand
            }}</span>
          </template>
        </el-table-column>
        <el-table-column property="carSerialNumber" label="设备序列号" width="100">
        </el-table-column>
        <el-table-column property="createUser" label="创建人">
        </el-table-column>
        <el-table-column property="orderExpectDoorTime" label="期望上门/处理时间" width="170">
        </el-table-column>
        <el-table-column property="orderRemark" label="备注">
        </el-table-column>
        <el-table-column property="createTime" label="申请时间" width="180">
        </el-table-column>
        <el-table-column label="操作" width="170" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="goDetail(scope.row)">详情</el-button>
            <el-button type="text" @click="goEditor(scope.row)"
              v-if="(scope.row.orderStatus == 10 || scope.row.orderStatus == 11) && scope.row.createUser == userInfo.userId">修改</el-button>
            <el-button type="text" @click="goRollback(scope.row)"
              v-if="scope.row.orderStatus == 30 && scope.row.workUser == userInfo.userId">返还</el-button>
            <el-button type="text" @click="goVoucher(scope.row)"
              v-if="(scope.row.orderStatus == 30 || scope.row.orderStatus == 31) && scope.row.workUser == userInfo.userId">凭证上传</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="paging_box">
        <!--  :current-page="currentPage4" -->
        <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size.sync="tableParams.limit" :current-page.sync="tableParams.page"
          layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 新增 -->
    <v-add :show.sync="addShow"></v-add>
    <!-- 修改 -->
    <v-redact :show.sync="redactShow" :data="redactData"></v-redact>
    <!-- 返还 -->
    <v-voucher :show.sync="voucherShow" :data="voucherData"></v-voucher>
    <!-- 凭证上传 -->
    <v-rollback :show.sync="rollbackShow" :data="rollbackData"></v-rollback>
    <v-detail :show.sync="detailShow" :data="detailData"></v-detail>
  </div>
</template>

<script>
import add from "./component/add.vue";
import redact from "./component/redact.vue";
import voucher from "./component/voucher.vue";
import rollback from "./component/rollback.vue";
import detail from "./component/detail.vue";
import { dateTransition } from "@/utils/util.js";
import config from '@/utils/config';
export default {
  name: "",
  data () {
    return {
      tableData: [],
      tableParams: {},
      total: 0,
      addShow: false,
      voucherShow: false,
      voucherData: {},
      rollbackShow: false,
      rollbackData: {},
      detailShow: false,
      detailData: {},
      tableLoading: false,
      stateList: [],
      timeList: [],
      tableParams: {
        page: 1,
        limit: 10,
        searchParam: "", // 搜索内容(联系人，联系人电话)
        orderStatus: "", // 工单状态,
        startTime: "", // 开始时间
        endTime: "", // 结束时间
        orderType: null, // 工单类型
      },
      redactData: {},
      redactShow: false,
      OrderNumData: {},
      orderTypeList: [],
      orderStateList: [],
      userInfo: {}
    };
  },
  components: {
    "v-add": add,
    "v-redact": redact,
    "v-voucher": voucher,
    "v-rollback": rollback,
    "v-detail": detail,
  },
  props: {},
  created () {
    this.getList();
    this.getOrderNum();
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
    this.$http.queryDist({ type: "工单类型" }).then((res) => {
      if (res.code === 0) {
        this.orderStateList = res.data;
      } else {
        this.orderStateList = [];
      }
    });
    this.$http.queryDist({ type: "工单状态" }).then((res) => {
      if (res.code === 0) {
        this.orderTypeList = res.data;
      } else {
        this.orderTypeList = [];
      }
    });
  },
  methods: {
    getList () {
      this.tableLoading = true;
      this.$http.queryWorkOrderList(this.tableParams).then((res) => {
        this.tableLoading = false;
        if (res.code === 0) {
          this.tableData = res.data;
          this.total = res.count;
          // this.$message.success(res.msg);
        } else {
          this.tableData = [];
          this.total = 0;
          this.$message.error(res.msg);
        }
      });
    },
    goRollback (row) {
      this.rollbackShow = true;
      this.rollbackData = row;
    },
    goVoucher (row) {
      this.voucherShow = true;
      this.voucherData = row;
    },
    timeChange (e) {
      if (e == null) {
        this.tableParams.startTime = "";
        this.tableParams.endTime = "";
      } else {
        this.tableParams.startTime = dateTransition(e[0]);
        this.tableParams.endTime = dateTransition(e[1]);
      }
    },
    getOrderNum () {
      this.$http.queryWorkOrderCount().then((res) => {
        if (res.code === 0) {
          this.OrderNumData = res.data;
        } else {
          this.OrderNumData = {};
          this.$message.error(res.msg);
        }
      });
    },
    downloadExport() {
      var data=this.tableParams;
      var url=config.baseUrl+'/workOrder/exportWorkOrderList?Authorization='+sessionStorage.getItem("Token");
      if(data.searchParam){
        url+='&searchParam='+data.searchParam;
      }
      if(data.orderStatus){
        url+='&orderStatus='+data.orderStatus;
      }
      if(data.startTime){
        url+='&startTime='+data.startTime;
      }
      if(data.endTime){
        url+='&endTime='+data.endTime;
      }
      if(data.orderType){
        url+='&orderType='+data.orderType;
      }
      window.open(url, '_blank');
    },
    onSubmit () {
      this.getList();
    },
    handleSizeChange (val) {
      this.tableParams.limit = val;
      this.tableParams.page = 1;
      this.getList();
    },
    handleCurrentChange (val) {
      this.tableParams.page = val;
      this.getList();
    },
    addData () {
      this.addShow = true;
      this.editorData = null
    },
    goEditor (row) {
      this.redactShow = true;
      this.redactData = row
    },
    goDetail (row) {
      this.detailShow = true;
      this.detailData = row;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/comm.less";
</style>



// WEBPACK FOOTER //
// src/views/workOrder_Admin/workOrder_Admin.vue